<template>
  <div class="tobepaid safe-distance-top-header">
    <Header pageTitle="订单详情" :goUrl="goBackUrl" />
    <div class="tobepaid_bottom">
      <!-- 订单详情 -->
      <div class="orderState">
        <!-- 6已取消 7已过期 -->
        <img
          v-if="status == 6 || status == 7"
          :src="require('@/assets/mylogin/quxiao@2x.png')"
          alt=""
        />
        <!-- 1 待付款 3 待发货 4 已发货（待收货） -->
        <img
          v-else-if="status == 1 || status == 3 || status == 4"
          :src="require('@/assets/mylogin/dengdai@2x.png')"
          alt=""
        />

        <div class="state">{{ statusText }}</div>
      </div>
      <!-- 物流状态 图书商品-->
      <div
        v-if="goodsList[0].goodsType == 1 && status == 4"
        class="logistics-status"
      >
        <van-steps
          active-color="#FF3D3D"
          inactive-color="#FF3D3D"
          direction="vertical"
          :active="0"
          class="logistics-step"
        >
          <van-step>
            <div class="logistics-status-btn">
              <div>
                <span v-if="loading && expressList.length" class="has-status">{{
                  expressList[0].status
                }}</span>
                <span v-if="loading && !expressList.length">暂无信息</span>
              </div>
              <div @click="toLogistics()" style="cursor: pointer">
                查看详情<van-icon style="margin-left: 5px" name="arrow" />
              </div>
            </div>
            <div class="logistics-status-text">
              <span v-if="loading && expressList.length">{{
                expressList[0].context
              }}</span>
              <span v-if="loading && !expressList.length">暂无物流信息</span>
            </div>
          </van-step>
          <van-step>
            <div class="user-address">
              <span v-html="userAddress.provinceName"></span>
              <span v-html="userAddress.cityName"></span>
              <span v-html="userAddress.districtName"></span>
              <span v-html="userAddress.streetName"></span>
              <span v-html="userAddress.detailAddress"></span>
            </div>
            <div class="user-msg">
              <span class="user-name" v-html="userAddress.consignee"></span>
              <span v-if="userAddress.phone">{{
                userAddress.phone.substring(0, 3) +
                "****" +
                userAddress.phone.substring(7)
              }}</span>
            </div>
          </van-step>
        </van-steps>
      </div>
      <!-- 待支付订单显示倒计时 -->
      <div v-if="status == 1" class="countdown-area">
        <!-- v-show="hours != '' && minutes != '' && seconds != ''" -->
        <p>
          剩余<span>{{ hours }}</span
          >时<span>{{ minutes }}</span
          >分<span>{{ seconds }}</span
          >秒关闭
        </p>
      </div>
      <!-- 地址 图书商品有收货地址，显示收货地址 -->
      <div
        v-if="goodsList[0].goodsType == 1 && status != 4"
        class="address_bottom"
      >
        <div class="img">
          <img :src="require('@/assets/mylogin/address.png')" alt="" />
        </div>
        <div class="address_information">
          <p class="province">
            <span v-html="userAddress.provinceName"></span>
            <span v-html="userAddress.cityName"></span>
            <span v-html="userAddress.districtName"></span>
            <span v-html="userAddress.streetName"></span>
          </p>
          <p class="specificAddress">{{ userAddress.detailAddress }}</p>
          <p class="name">
            <span v-html="userAddress.consignee"></span>
            <span v-if="userAddress.phone">{{
              userAddress.phone.substring(0, 3) +
              "****" +
              userAddress.phone.substring(7)
            }}</span>
          </p>
        </div>
      </div>
      <!-- 商品名称 -->
      <div class="commodity_name">
        <div class="title">{{ goodsList[0].shopName }}</div>
        <div class="contents">
          <div class="commodity_name_left">
            <img
              v-if="
                goodsList[0].goodsType !== '5' && goodsList[0].goodsType !== '6'
              "
              :src="
                albumPics
                  ? $global.imgUrl + albumPics
                  : require('@/assets/img/mobile-img/zz_default.png')
              "
              alt=""
            />
            <img
              v-else
              src="@/assets/img/mobile-img/paper-default.png"
              alt=""
            />
          </div>
          <div class="commodity_name_right">
            <div class="commodity_name_right_top">
              <div class="name">{{ goodsList[0].goodsName }}</div>
              <div
                class="specifications"
                v-if="
                  goodsList[0].goodsType !== '5' &&
                  goodsList[0].goodsType !== '6'
                "
              >
                <div class="price">¥{{ goodsList[0].saleAmount }}</div>
                <div class="number">×{{ goodsList[0].saleNum }}</div>
              </div>
            </div>
            <div class="commodity_name_right_bottm">
              <span>
                <span v-html="goodsList[0].specificationsValueOne"></span>
                <span v-html="goodsList[0].specificationsValueTwo"></span>
              </span>
              <div
                v-if="
                  goodsList[0].goodsType === '5' ||
                  goodsList[0].goodsType == '6'
                "
                class="number"
              >
                ×{{ goodsList[0].saleNum }}
              </div>
            </div>
            <div
              v-if="
                goodsList[0].goodsType === '5' || goodsList[0].goodsType == '6'
              "
              class="price_box"
            >
              <span>¥{{ goodsList[0].saleAmount }}</span>
            </div>
          </div>
        </div>
        <div
          class="but-box"
          v-if="afterSalesStatus.includes(goodsList[0].afterSalesStatus)"
        >
          <button
            class="button_2-0"
            style="margin-left: 10px"
            @click="
              afterSalesOrderFun(
                goodsList[0].afterSalesOrderId,
                goodsList[0].afterSalesStatus
              )
            "
          >
            <span class="text_17-0">
              {{
                afterText(
                  goodsList[0].afterSalesOrderId,
                  goodsList[0].afterSalesStatus
                )
              }}
            </span>
          </button>
        </div>
      </div>
      <!-- 应付款 -->
      <div class="Accountspayable">
        <van-cell-group>
          <van-cell :title="status | paymentText" :value="`￥${totalPrice}`" />
        </van-cell-group>
      </div>
      <!-- 订单信息 -->
      <div class="Ordering">
        <div class="text">订单信息</div>
        <div class="orderGoods">
          <div class="explain_goods">订单编号</div>
          <div class="number">{{ goodsList[0].orderId }}</div>
        </div>
        <div class="Ordertime" v-if="email">
          <div class="explain_tiem">邮箱</div>
          <div class="time">{{ email }}</div>
        </div>
        <div class="Ordertime" v-if="remark">
          <div class="explain_tiem">订单备注</div>
          <div class="explain_tiem_remark">{{ remark }}</div>
        </div>
        <div class="Ordertime">
          <div class="explain_tiem">下单时间</div>
          <div class="time">{{ goodsList[0].createTime }}</div>
        </div>
        <div class="Ordertime" v-if="payWaySupplierName">
          <div class="explain_tiem">支付方式</div>
          <div class="time">{{ payWaySupplierName }}</div>
        </div>
      </div>
      <!-- 参会人信息 会议类型存在 -->
      <div
        v-if="goodsList[0].goodsType == 2 && meetingMemberNameList.length"
        class="Participant"
      >
        <van-cell-group>
          <van-cell title="参会人信息" value="" />
        </van-cell-group>
        <van-cell-group>
          <van-cell
            v-for="member in meetingMemberNameList"
            :title="member.name"
            :key="member.id"
            is-link
            :to="{
              path: '/memberInfoInOrder',
              query: { id: member.id, goodsId: member.goodsId },
            }"
          />
        </van-cell-group>
      </div>
      <!-- 底部按钮 -->
      <div class="bottom">
        <!-- 待发货和已完成暂不显示按钮 v-show="status != 3 && status != 5"-->
        <div class="block_4-0">
          <!-- 已关闭订单（订单过期或者取消）显示删除按钮 -->
          <div v-if="status == 6 || status == 7">
            <!-- 订单分主订单，子订单；当前版本没有主订单，删除操作只涉及子订单 传递子订单编号 -->
            <button class="button_2-0" @click="delSubOrder()">
              <span class="text_17-0">删除订单</span>
            </button>
          </div>
          <!-- 待付款订单 -->
          <div v-if="status == 1">
            <button class="button_2-0" @click="cancelOrder(payBatchId)">
              <span class="text_17-0">取消订单</span>
            </button>
            <button class="button_3-0" @click="payPopUp = true">
              <span class="text_18-0">立即付款</span>
            </button>
          </div>
          <!-- 已发货/待收货 -->
          <div v-if="status == 4">
            <button
              v-if="!hasApplyInvoice"
              class="button_2-0"
              @click="toInvoice"
            >
              <span class="text_17-0">开具发票</span>
            </button>
            <button
              v-if="hasApplyInvoice"
              class="button_2-0"
              @click="
                $router.push({
                  path: '/check-invoice',
                  query: { orderInvoiceId: subOrderDetail.orderInvoiceId },
                })
              "
            >
              <span class="text_17-0">查看发票</span>
            </button>
            <button class="button_3-0" @click="confirmReceipt()">
              <span class="text_18-0">确认收货</span>
            </button>
          </div>
          <!-- 已支付，待发货，已收货，支付完成都显示售后 -->
          <div v-if="status == 2 || status == 3 || status == 5">
            <!-- 订单分主订单，子订单；当前版本没有主订单，删除操作只涉及子订单 传递子订单编号 -->
            <button
              v-if="!hasApplyInvoice"
              class="button_2-0"
              @click="toInvoice"
            >
              <span class="text_17-0">开具发票</span>
            </button>
            <button
              v-if="hasApplyInvoice"
              class="button_2-0"
              @click="
                $router.push({
                  path: '/check-invoice',
                  query: { orderInvoiceId: subOrderDetail.orderInvoiceId },
                })
              "
            >
              <span class="text_17-0">查看发票</span>
            </button>
            <button
              v-if="goodsList[0].goodsType == 1 && status == 5"
              class="button_2-0"
              style="margin-left: 10px"
              @click="toLogistics()"
            >
              <span class="text_17-0">查看物流</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- 支付弹窗 -->
    <van-popup
      v-model="payPopUp"
      closeable
      position="bottom"
      class="pay-popup"
      @close="payPopUp = false"
    >
      <!-- 支付金额 -->
      <h1>
        <span class="currency">￥</span
        ><span class="pay-price">{{
          (goodsList[0].saleAmount * goodsList[0].saleNum).toFixed(2)
        }}</span>
      </h1>
      <!-- 支付方式 -->
      <div class="payment">
        <div class="title">选择支付方式</div>
        <div class="option">
          <van-radio-group v-model="radio" direction="horizontal">
            <div class="zhifubao">
              <img src="@/assets/mylogin/zhifubao-logo.png" alt="" />
              <div class="option_name">支付宝</div>
            </div>
            <van-radio name="1" style="margin-top: 18px"></van-radio>
            <div class="weixin">
              <img src="@/assets/mylogin/weixinzhifu2@2x.png" alt="" />
              <div class="option_name">微信支付</div>
            </div>
            <van-radio name="2" style="margin-top: 18px"></van-radio>
          </van-radio-group>
        </div>
        <!-- 确认支付 -->
        <van-button type="info" class="pay-now" @click="toPay"
          >确认支付</van-button
        >
      </div>
    </van-popup>
  </div>
</template>

<script>
import Header from "@/views/mobileView/components/header/index.vue";
import { Dialog } from "vant";
export default {
  name: "tobepaid",
  components: {
    Header,
  },
  data() {
    return {
      goodsList: [
        {
          albumPics: "",
          aooountId: null,
          createTime: "",
          creditPeriod: null,
          divideAccountNode: null,
          divideAccountsSettings: "",
          divideSettingObject: [
            {
              accountId: null,
              accountName: "",
              divideProportion: null,
            },
          ],
          goodsId: null,
          goodsKeywords: "",
          goodsName: "",
          goodsSkuValuesId: null,
          goodsType: null,
          goodsWeight: null,
          id: null,
          isNoReasonSeven: null,
          orderId: null,
          payBatchId: "",
          payStatus: null,
          saleAmount: null,
          saleNum: null,
          shopId: null,
          shopName: "",
          specificationsValueOne: "",
          specificationsValueTwo: "",
          transferDate: "",
          userId: null,
          virtualGoods: null,
        },
      ],

      logisticsName: "",
      logisticsNum: "",

      payBatchId: "",
      payCreateTime: "",

      receiveMobile: "",
      receiveName: "",

      status: null,
      statusString: "",
      payWaySupplierName: "", // 支付方式

      userAddress: {
        /*
        cityCode: null,
        cityName: "",
        consignee: "",
        createTime: "",
        detailAddress: "",
        districtCode: null,
        districtName: "",
        id: null,
        payBatchId: "",
        phone: "",
        postalCode: "",
        provinceCode: null,
        provinceName: "",
        streetCode: null,
        streetName: "",
        userId: null,
        */
      },

      userId: null,
      // --------------------------------------
      primaryOrderDetail: {},
      subOrderDetail: {},

      // --------------------------------------
      // 会议报名人姓名列表
      meetingMemberNameList: [],
      // 倒计时时分秒
      totalSeconds: null,
      hours: "00",
      minutes: "00",
      seconds: "00",
      timer: null,
      // 支付弹窗
      payPopUp: false,
      // 支付方式 1支付宝 2 微信
      radio: "",
      afterSalesStatus: [1, 2, 3],
      email: "",
      remark: "",
      expressList: [], // 物流状态信息
      loading: false, // 请求完数据渲染页面
      hasApplyInvoice: true, // 是否已经开具发票
      goBackUrl: "",
    };
  },
  computed: {
    statusText() {
      var str = this.statusString;
      if (this.status == 4) {
        str = "待收货";
      } else if (this.status == 6 || this.status == 7) {
        str = "交易关闭";
      }
      return str;
    },
    totalPrice() {
      var price = (
        this.goodsList[0].saleAmount * this.goodsList[0].saleNum
      ).toFixed(2);
      return price;
    },
    // 商品封面
    albumPics() {
      var goodsPicUrl = "";
      if (this.goodsList[0].albumPics) {
        if (this.goodsList[0].albumPics.indexOf(",") != -1) {
          // 多张封面图取第一张
          goodsPicUrl = this.goodsList[0].albumPics.split(",")[0];
        } else {
          goodsPicUrl = this.goodsList[0].albumPics;
        }
      } else {
        return "";
      }
      return goodsPicUrl;
    },
  },
  watch: {
    totalSeconds(val) {
      this.countDownTime(val);
    },
  },
  filters: {
    paymentText(type) {
      switch (type) {
        case 1:
          return "待付款";
        case 6:
        case 7:
          return "应付款";
        case 3:
        case 4:
        case 5:
          return "实付款";
      }
    },
  },
  created() {
    // 详情
    const _this = this;
    this.timer && clearTimeout(this.timer);
    _this.status = _this.$route.query.status;
    _this.payBatchId = _this.$route.query.id;
    _this.payCreateTime = _this.$route.query.createTime;

    _this.radio = _this.$route.query.payType ? _this.$route.query.payType : "1";

    document.addEventListener("visibilitychange", this.visibilitychangeFN, {
      passive: false,
    });
    _this.orderDetails();
  },
  methods: {
    toInvoice() {
      // if (this.subOrderDetail.applyInvoicePrice > 0) {
        let query = {
          from: "orderDetail",
          orderId: this.goodsList[0].orderId,
          invoicePrice: this.subOrderDetail.applyInvoicePrice,
          createTime: this.goodsList[0].createTime,
        };
        this.$router.push({ path: "/invoice", query });
      // } else {
      //   Dialog.alert({
      //     message: "订单可开票金额为0，无法申请发票！",
      //     theme: "round-button",
      //   });
      // }
    },
    visibilitychangeFN() {
      if (document.visibilityState === "visible") {
        this.payPopUp = false;
        this.orderDetails();
      }
    },
    afterText(id, status) {
      switch (status) {
        case 1:
          return id ? "售后详情" : "退换/售后";
        case 2:
          return "售后中";
        case 3:
          return "售后完成";
      }
    },
    afterSalesOrderFun(id, status) {
      if (status === 1) {
        if (id) {
          this.$router.push({
            path: "/aftermarketInfo",
            query: { id },
          });
        } else {
          if (this.goodsList[0].checkAfterSalesTime) {
            this.$router.push({
              path: "/selectAfterSalesType",
              query: {
                id: this.goodsList[0].id,
                goodsType: this.goodsList[0].goodsType,
                status: this.status,
              },
            });
          } else {
            Dialog.confirm({
              message: "抱歉，订单已超过售后申请时效",
              confirmButtonText: "联系平台",
              cancelButtonText: "确认",
              confirmButtonColor: "#32ae57",
            })
              .then(() => {
                this.$router.push({ path: "/afterSale", query: { type: 2 } });
              })
              .catch(() => {});
          }
        }
      } else {
        this.$router.push({
          path: "/aftermarketInfo",
          query: { id },
        });
      }
    },
    // 查询订单详情
    async orderDetails() {
      const _this = this;
      if (_this.$route.query.status == 1) {
        await _this.getPrimaryOrderDetail(_this.$route.query.id);
      } else {
        await _this.getSubOrderDetial(_this.$route.query.id);
      }
      // 如果当前商品是会议，需额外查询参会人信息
      if (_this.goodsList[0].goodsType == 2) {
        var resp = await _this.$apis.myServe.meetingMemberInfoInOrders({
          payBatchId: _this.goodsList[0].payBatchId,
        });
        if (resp.resultCode == 200) {
          _this.meetingMemberNameList = resp.data.map((member) => {
            return {
              name: member.name,
              id: member.id,
              goodsId: _this.goodsList[0].goodsId,
            };
          });
        } else {
          _this.$toast(resp.resultDesc);
        }
      }
    },
    // 待付款，查询主订单详情
    async getPrimaryOrderDetail(payBatchId) {
      const _this = this;
      var res = await _this.$apis.myServe.primaryOrderDetail({
        payBatchId,
      });
      if (res.resultCode == 200) {
        if (res.data.orderList[0].status === 1) {
          _this.totalSeconds = Math.round(+res.data.expireTime / 1000);
          // 获取订单过期时间（毫秒）
          _this.countDownTime(_this.totalSeconds);
          // 处理订单数据
          Object.keys(res.data).forEach((key) => {
            _this.$set(_this.primaryOrderDetail, key, res.data[key]);
          });
          _this.userAddress = res.data.userAddress || {};
          _this.goodsList = res.data.orderList[0].goodsList;
          _this.status = res.data.orderList[0].status;
          _this.statusString = res.data.orderList[0].statusString;
          _this.payBatchId = res.data.payBatchId;
          _this.payCreateTime = res.data.createTime;
          _this.email = res.data.email;
          _this.remark = res.data.remark;
          _this.payWaySupplierName = res.data.payWaySupplierName;
        } else {
          this.$router.replace({
            path: "/orderDetails",
            query: {
              id: res.data.orderList[0].goodsList[0].orderId,
              status: res.data.orderList[0].status,
            },
          });
        }
      } else {
        _this.$toast(res.resultDesc);
      }
    },
    // 非待支付订单一律 查询子订单详情
    async getSubOrderDetial(id) {
      const _this = this;
      var res = await _this.$apis.myServe.subOrderDetial({ id });
      if (res.resultCode == 200) {
        this.hasApplyInvoice = res.content.hasApplyInvoice;
        // 处理订单数据
        Object.keys(res.data).forEach((key) => {
          _this.$set(_this.subOrderDetail, key, res.data[key]);
        });
        this.payWaySupplierName = res.data.payWaySupplierName;
        _this.userAddress = res.data.userAddress || {};
        _this.goodsList = res.data.goodsList;
        _this.status = res.data.status;
        _this.statusString = res.data.statusString;
        _this.logisticsName = res.data.logisticsName
          ? res.data.logisticsName
          : "";
        _this.logisticsNum = res.data.logisticsNum ? res.data.logisticsNum : "";
        _this.payBatchId = res.data.goodsList[0].payBatchId;
        _this.email = res.data.primaryOrder.email;
        _this.remark = res.data.primaryOrder.remark;
        if (
          this.$route.query.id &&
          res.data.orderType === 1 &&
          (res.data.status === 4 || res.data.status === 5)
        ) {
          this.orderExpress();
        }
      } else {
        _this.$toast(res.resultDesc);
      }
    },
    // 获取物流信息
    orderExpress() {
      let params = {
        subOrderId: this.$route.query.id,
      };
      this.loading = false;
      this.$apis.myServe.orderExpress(params).then((res) => {
        if (
          res.data.expressRecord &&
          res.data.expressRecord.callbackJson &&
          res.data.expressRecord.callbackJson.lastResult &&
          res.data.expressRecord.callbackJson.lastResult.data
        ) {
          this.expressList =
            res.data.expressRecord.callbackJson.lastResult.data;
        }
        let obj = {
          list: this.expressList,
          name: this.logisticsName,
          number: this.logisticsNum,
        };
        sessionStorage.setItem("logisticsStatus", JSON.stringify(obj));
        this.loading = true;
      });
    },
    // 处理倒计时
    countDownTime() {
      const _this = this;
      _this.timer = setTimeout(() => {
        _this.getTime();
      }, 1000);
    },

    getTime() {
      this.timer && clearTimeout(this.timer);
      this.totalSeconds -= 1;
      if (this.totalSeconds == 0) {
        this.$router.replace({
          path: "/orderDetails",
          query: { id: this.goodsList[0].orderId, status: 7 },
        });
      }
      const { dd, hh, mm, ss } = this.timeFormatter(this.totalSeconds);
      this.hours = hh || "00";
      this.minutes = mm || "00";
      this.seconds = ss || "00";
    },
    timeFormatter(time) {
      if (!time) return { dd: "0", hh: "0", mm: "0", ss: "0" };
      let t = time;
      const ss = t % 60;
      t = (t - ss) / 60;
      if (t < 1) return { dd: "0", hh: "0", mm: "0", ss };
      const mm = t % 60;
      t = (t - mm) / 60;
      if (t < 1) return { dd: "0", hh: "0", mm, ss };
      const hh = t % 24;
      t = (t - hh) / 24;
      if (t < 1) return { dd: "0", hh, mm, ss };
      const dd = t;
      return { dd, hh, mm, ss };
    },
    // 删除订单
    async delSubOrder() {
      const _this = this;
      Dialog.confirm({
        message: "确认删除该订单？",
        // theme: "round-button",
        confirmButtonColor: "#4A79F1",
        // cancelButtonColor: "#eee",
        cancelButtonText: "取消",
        confirmButtonText: "确认删除",
        className: "confirm-receipt",
      })
        .then(async () => {
          // on confirm
          var res = await _this.$apis.myServe.delSubOrder({
            orderId: this.goodsList[0].orderId,
          });
          if (res.resultCode == 200) {
            // 删除成功
            _this.$router.push({ path: "/orders" });
          } else {
            _this.$toast(res.resultDesc);
          }
        })
        .catch(() => {
          // on cancel
        });
    },
    // 取消订单
    async cancelOrder(payBatchId) {
      const _this = this;

      Dialog.confirm({
        message: "确认取消该订单？",
        // theme: "round-button",
        confirmButtonColor: "#4A79F1",
        // cancelButtonColor: "#eee",
        cancelButtonText: "取消",
        confirmButtonText: "确认取消",
        className: "confirm-receipt",
      })
        .then(async () => {
          // on confirm
          var res = await _this.$apis.myServe.cancelOrder({
            payBatchId: payBatchId,
          });
          if (res.resultCode == 200) {
            this.$router.replace({
              path: "/orderDetails",
              query: { id: _this.goodsList[0].orderId, status: 6 },
            });
          } else {
            _this.$toast(res.resultDesc);
          }
        })
        .catch(() => {
          // on cancel
        });
    },
    //  确认支付
    toPay() {
      if (this.radio === "1") {
        this.zhifubaoGetPay();
      } else {
        this.weixinGetPay();
      }
    },
    // 银联支付宝接口
    async zhifubaoGetPay() {
      const resp = await this.$apis.paymentServe.getPay({
        payBatchId: this.payBatchId,
        createTime: this.payCreateTime,
        payType: "h5_ali",
      });
      location.href = resp.data;
    },
    // 银联微信接口
    async weixinGetPay() {
      const resp = await this.$apis.paymentServe.getPay({
        merAppId: this.$global.zhifu,
        payBatchId: this.payBatchId,
        createTime: this.payCreateTime,
        payType: "h5_wx",
        sceneType: this.$global.isAndroid_ios() ? "AND_WAP" : "IOS_WAP",
      });
      location.href = resp.data;
    },
    // 确认收货
    confirmReceipt() {
      const _this = this;
      Dialog.confirm({
        message: "是否确认收货",
        // theme: 'round-button',
        confirmButtonColor: "#4A79F1",
        // cancelButtonColor: "#FFFFFF"
        // cancelButtonColor: "#eee",
        cancelButtonText: "取消",
        confirmButtonText: "确认",
      })
        .then(async () => {
          // on confirm
          const res = await _this.$apis.myServe.receiptConfirm({
            id: this.goodsList[0].orderId,
          });
          if (res.resultCode == 200) {
            _this.orderDetails();
          } else {
            _this.$toast(res.resultDesc);
          }
        })
        .catch(() => {
          // on cancel
        });
    },
    back() {
      window.history.go(-1);
    },
    toLogistics() {
      if (this.expressList && this.expressList.length) {
        this.$router.push({ path: "/logisticsStatus" });
      } else {
        this.$toast("暂无物流信息");
      }
    },
  },
  beforeRouteEnter(to, from, next) {
    // 通过 `vm` 访问组件实例
    next((vm) => {
      if (from.name === "refundRebate" || from.name === "aftermarketInfo") {
        vm.goBackUrl = "/orders";
      } else if (
        from.name === "bookConfirmOrder" ||
        from.name === "ReportConfirmOrder" ||
        from.name === "CourseConfirmOrder" ||
        from.name === "meetingOrdeyPay"
      ) {
        vm.toPay();
      }
    });
  },
  beforeRouteLeave(to, from, next) {
    // 执行您的逻辑，比如移除事件监听器
    document.removeEventListener("visibilitychange", this.visibilitychangeFN, {
      passive: false,
    });
    // 继续路由导航
    next();
  },
};
</script>

<style lang="scss" scoped>
.tobepaid {
  width: 100vw;
  min-height: 100vh;
  overflow: hidden;
  background: #f5f5f5;

  .tobepaid_top {
    height: 44px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #fff;
    line-height: 44px;

    .my {
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      background: #fff;
    }
  }

  .tobepaid_bottom {
    overflow: hidden;

    .orderState {
      width: 100px;
      height: 20px;
      display: flex;
      margin: 20px auto;
      justify-content: center;
      align-items: center;

      img {
        width: 16px;
        height: 16px;
      }

      .state {
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
        line-height: 23px;
        margin-left: 3px;
        flex-shrink: 0;
      }
    }

    .countdown-area {
      width: 100%;
      text-align: center;
    }

    .logistics-status {
      width: 94%;
      margin: 12px auto;
      border-radius: 8px 8px 8px 8px;
      background: #fff;
      display: flex;
      padding: 12px 0px 12px 12px;

      .logistics-step {
        width: 100%;

        .logistics-status-btn {
          display: flex;
          justify-content: space-between;
          color: #666666;

          .has-status {
            font-weight: bold;
            font-size: 15px;
            color: #ff3d3d;
            line-height: 21px;
          }
        }

        .logistics-status-text {
          font-size: 13px;
          padding-top: 10px;
          line-height: 20px;
          color: #666666;
          word-break: break-all;
          overflow: hidden;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }

        .user-address {
          font-weight: bold;
          font-size: 15px;
          color: #333333;
          line-height: 21px;
        }

        .user-msg {
          font-size: 14px;
          color: #666666;
          line-height: 20px;
          margin-top: 5px;

          .user-name {
            margin-right: 10px;
          }
        }
      }
    }

    .address_bottom {
      width: 94%;
      margin: 12px auto;
      border-radius: 8px 8px 8px 8px;
      background: #fff;
      display: flex;
      padding: 12px 0px 12px 12px;

      .img {
        width: 30px;
        margin-top: 23px;

        img {
          width: 30px;
          height: 30px;
        }
      }

      .address_information {
        margin-left: 12px;

        .province {
          margin-top: 6px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #999999;
          line-height: 20px;
        }

        .specificAddress {
          margin-top: 6px;
          font-size: 15px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #333333;
          line-height: 21px;
        }

        .name {
          margin-top: 6px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
          line-height: 20px;
          display: flex;
          justify-content: flex-start;
          align-items: center;

          span {
            margin-right: 10px;
            flex-shrink: 0;
          }

          span:first-child {
            max-width: 100px;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
      }
    }

    .logistics {
      width: 94%;
      // height: 88px;
      margin: 0 auto;
      background: #fff;
      border-radius: 8px;
      padding: 10px 0;

      .information {
        display: flex;
        padding: 0 0px 0px 15px;

        img {
          width: 16px;
          height: 16px;
          vertical-align: middle;
          margin-top: 3px;
        }

        div {
          font-size: 15px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #333333;
          line-height: 21px;
        }
      }

      .numbers {
        font-size: 15px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        line-height: 20px;
        padding: 15px 15px 0px 15px;
        display: flex;
        flex-wrap: wrap;

        span {
          flex-shrink: 0;
          word-wrap: break-word;
          max-width: 100%;
        }
      }
    }

    .commodity_name {
      padding: 12px;
      margin-bottom: 12px;
      background: #fff;
      border-radius: 8px;
      // height: 195px;
      width: 94%;
      margin: 12px auto;

      .title {
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
        line-height: 20px;
      }

      .contents {
        display: flex;
        margin-top: 15px;

        .commodity_name_left {
          flex: none;
          margin-right: 10px;
          width: 80px;
          height: 80px;

          img {
            width: 100%;
            height: 100%;
            object-fit: contain;
          }
        }

        .commodity_name_right {
          width: 100%;
          .commodity_name_right_top {
            display: flex;
            .name {
              flex: none;
              width: 178px;
              font-size: 15px;
              font-weight: 500;
              color: #333333;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }

            .specifications {
              .price {
                font-size: 12px;
                font-weight: 500;
                color: #333333;
              }

              .number {
                margin-top: 5px;
                font-size: 13px;
                color: #999999;
              }
            }
          }

          .commodity_name_right_bottm {
            display: flex;
            justify-content: space-between;
            margin-top: 5px;
            width: 100%;
            font-size: 13px;
            color: #999999;
            .number {
              font-size: 13px;
              color: #999999;
            }
          }
          .price_box {
            margin-top: 10px;
            font-size: 16px;
            font-weight: 500;
            color: #333333;
            line-height: 17px;
          }
        }
      }

      .but-box {
        text-align: right;

        .but {
          width: 80px;
          height: 32px;
          padding: 0px 5px;
          background: #fff;
          border: 1px solid #cccccc;
          margin-top: 20px;

          .van-button__text {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
            line-height: 20px;
          }
        }
      }
    }

    .Accountspayable {
      width: 94%;
      height: 44px;
      margin: 0 auto;

      .van-cell-group {
        background: none;

        .van-cell {
          border-radius: 8px;

          .van-cell__value {
            span {
              font-size: 12px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #333333;
              line-height: 17px;
            }
          }
        }
      }
    }

    .Ordering {
      width: 94%;
      margin: 12px auto;
      background: #fff;
      border-radius: 8px;
      padding: 15px;

      .text {
        font-size: 15px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
        line-height: 21px;
      }

      .orderGoods {
        display: flex;
        justify-content: space-between;
        margin-top: 18px;

        .explain_goods {
          width: 70px;
          font-size: 14px;
          color: #999999;
          line-height: 20px;
        }

        .number {
          text-align: right;
          font-size: 14px;
          color: #333333;
          line-height: 20px;
        }
      }

      .Ordertime {
        margin-top: 18px;
        display: flex;
        justify-content: space-between;

        .explain_tiem {
          width: 70px;
          font-size: 14px;
          color: #999999;
          line-height: 20px;
          flex-shrink: 0;
        }

        .explain_tiem_remark {
          text-align: right;
          font-size: 14px;
          color: #333333;
          line-height: 20px;
          word-break: break-all;
        }

        .time {
          text-align: right;
          font-size: 14px;
          color: #333333;
          line-height: 20px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }

    .Participant {
      width: 94%;
      margin: 12px auto;
      border-radius: 8px;
      overflow: hidden;

      .van-cell-group {
        background: none;
      }
    }
  }

  .bottom {
    background: #fff;
    width: 100%;
    height: 55px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding-right: 10px;

    // .block_4-0 {
    //   width: 100%;
    //   text-align: right;
    //   height: 100%;

    .button_2-0 {
      width: 80px;
      height: 32px;
      border-radius: 16px;
      border: 1px solid #cccccc;
      border: none;

      .text_17-0 {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
      }
    }

    .button_3-0 {
      border: none;
      width: 80px;
      height: 32px;
      background: #397bf9;
      border-radius: 16px;

      margin-left: 10px;

      .text_18-0 {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffffff;
      }
    }
  }

  .pay-popup {
    height: 351px;

    // 价格
    h1 {
      text-align: center;
      margin: 33px auto 27px auto;

      .currency {
        // 币种
        font-size: 12px;
      }

      .pay-price {
        font-size: 25px;
      }
    }

    .payment {
      padding: 12px;
      margin-bottom: 12px;
      background: #fff;
      border-radius: 8px;
      height: 154px;

      .title {
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
        line-height: 20px;
      }

      .option {
        .zhifubao {
          display: flex;
          margin-top: 24px;

          img {
            width: 30px;
            height: 30px;
          }

          .option_name {
            font-size: 15px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
            line-height: 27px;
            margin-left: 15px;
            width: 250px;
          }

          .img-icon {
            width: 20px;
            height: 20px;
          }
        }

        .weixin {
          display: flex;
          margin-top: 20px;

          img {
            width: 30px;
            height: 30px;
          }

          .option_name {
            font-size: 15px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
            line-height: 27px;
            margin-left: 15px;
            width: 250px;
          }

          .img-icon {
            width: 20px;
            height: 20px;
          }
        }
      }
    }

    .van-radio__icon--checked .van-icon {
      background: #4a79f1;
    }

    // 确认支付按钮
    .pay-now {
      width: 345px;
      height: 44px;
      background: #4a79f1;
      border-radius: 22px;
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffffff;
      margin: 45px auto 0 auto;
    }
  }

  .button_2-0 {
    width: 80px;
    height: 32px;
    border-radius: 16px;
    border: 1px solid #cccccc;
    border: none;

    .text_17-0 {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
    }
  }
}
</style>
